// extracted by mini-css-extract-plugin
export default {"root":"IconEyeOpen_root__JMPqs"};